<app-dialog-header>Copy user settings</app-dialog-header>

<div
  appDialogContent
  class="dialog-content">
  <app-select
    label="Donor"
    placeholder="Choose a user to copy settings from"
    searchPlaceholder="Search by name or email"
    searchable
    clearable
    [options]="donorOptions()"
    [value]="donorId()"
    (valueChange)="selectDonor($event)" />

  <section class="recipients">
    <div class="recipients-header">
      <span class="recipients-title">Recipients</span>
      <app-search-field
        class="recipients-search"
        placeholder="Search recipients"
        [disabled]="!donor()"
        [(value)]="recipientSearch" />
    </div>

    <div
      class="recipients-list"
      [class.list-disabled]="!donor()">
      @if (loading()) {
        <div class="state">
          <app-loader />
        </div>
      } @else if (!donor()) {
        <p class="state">Choose a donor to select recipients</p>
      } @else {
        <div class="select-all-row">
          <app-checkbox
            appearance="plain"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            [disabled]="!filteredRecipients().length"
            (checkedChange)="toggleAll()">
            Select all
          </app-checkbox>
          @if (selectedCount()) {
            <app-chip>{{ selectedCount() }} selected</app-chip>
          }
        </div>

        <div class="list-items">
          @for (user of filteredRecipients(); track user.id) {
            <app-checkbox
              appearance="plain"
              class="user-row"
              [checked]="selectedIds().has(user.id)"
              (checkedChange)="toggleRecipient(user.id)">
              <span class="user-name">{{ user | fullName }}</span>
              <span class="user-email">{{ user.email }}</span>
            </app-checkbox>
          } @empty {
            <p class="state">No users found</p>
          }
        </div>
      }
    </div>
  </section>

  <p class="notice">
    <mat-icon aria-hidden="true">info</mat-icon>
    The current user settings of the selected members will be replaced.
  </p>
</div>

<div appDialogActions>
  <app-button
    variant="stroked"
    color="neutral"
    appDialogClose>
    Cancel
  </app-button>
  <app-button
    [disabled]="!canCopy()"
    (click)="copy()">
    Copy
  </app-button>
</div>
